import { UseQueryResult, keepPreviousData } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { useDebounce } from 'use-debounce'

import { parseUser, User } from '../../models/User'
import * as api from '../api'
import { useApiQuery } from '../useApiQuery'
import { ReturnsGroups, ReturnsUsers } from '../useInvalidate'

export default function useUserSuggestions(init?: string | null) {
  const [query, setQuery] = useState(init)

  const [currentQuery, debounceState] = useDebounce(query, 300)

  const result: UseQueryResult<User[]> = useApiQuery({
    queryKey: ['userSuggestions', ReturnsUsers, ReturnsGroups, currentQuery],
    placeholderData: keepPreviousData,
    queryFn: async () =>
      parseUser
        .array(
          (
            await api.get(
              `user?page=1&page_size=10&search=${encodeURIComponent(currentQuery || '')}&only_manageable=true`
            )
          )?.data
        )
        .filter(({ error }) => !error),
  })

  const suggestions = useMemo(() => result.data || [], [result.data])

  return {
    query,
    setQuery,
    suggestions,
    isFetching: result.isFetching || debounceState.isPending(),
    result,
  }
}
